import BaseReducer from "./BaseReducer";

class AgcCheckReducer extends BaseReducer {
  domain = "AGC Check";
  type = "Scanner";

  initialState = {
    user: "",
    siteCode: null,
    scanResult: { siteCode: "", location: "" },
    stopStream: false,
    timeChecked: null,
    questions: [
      {
        id: 1,
        label: "Is there anyone underage in the AGC?",
        name: "anyoneUnderage",
        value: null,
      },
      {
        id: 2,
        label: "Are there any self-excluded players in the AGC?",
        name: "anySelfExcludedPlayers",
        value: null,
      },
      {
        id: 3,
        label:
          "There are no machines tampered or damaged and no suspicious or criminal activity witnessed?",
        name: "allOk",
        value: null,
      },
      {
        id: 4,
        label: "Is the AGC clean and tidy?",
        name: "isCleanAndTidy",
        value: null,
      },
      {
        id: 5,
        label: "How many customers in the AGC?",
        name: "customersInAGC",
        value: 0,
      },
      {
        id: 6,
        label: "Have you completed a social interaction?",
        name: "hasCompletedSocialInteraction",
        value: null,
      },
      {
        id: 7,
        label: "Have you completed an observation?",
        name: "hasCompletedObservation",
        value: null,
      },
      {
        id: 8,
        label:
          "Do you need to complete a responsible gambling customer interaction ?",
        name: "requiresResponsibleGamblingInteraction",
        value: null,
      },
      {
        id: 9,
        label: "Is anyone in the AGC?",
        name: "anyoneInAGC",
        value: null,
      },
    ],
  };
}

const reducer = new AgcCheckReducer();

export default reducer;
